import Parse from "parse";
Parse.initialize(
  process.env.VUE_APP_PARSE_APP_ID,
  process.env.VUE_APP_PARSE_JS_KEY
);

// "oDfPr7R8MqKURdUqj4kx3N7Ibq8hgbSXOtyARchU",
// "EQvhK0ywHDwoZaeGQir7iZkdm2rrV1RQkyeuVs3q"

Parse.serverURL = "https://parseapi.back4app.com/";

window.fbAsyncInit = function() {
  Parse.FacebookUtils.init({
    appId: process.env.VUE_APP_FACEBOOK_APP_ID,
    status: true,
    cookie: true,
    xfbml: true,
    version: "v2.3"
  });
};

(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

export default Parse;
